// @sympllex/billing/plans — browser-safe per-action pricing config (NO Stripe SDK), so
// the frontend can render the estimate without bundling the Node SDK. PLAN-C4.4.
// Per-action model (confirmed 2026-05-29): one recurring licensed price; the tenant's
// subscription quantity = its count of active compliance actions. Flat tiers retired.
// Price IDs are NOT secrets. Stripe test-mode (acct "Aquino Compliance sandbox").
// Live-key swap overrides via env (STRIPE_PRICE_PER_ACTION); €/action figure is owner-set:
// €0.50 / action / month (50 euro cents), decided by the owner 2026-06-02.
export interface PerActionPrice {
  priceId: string;
  unitAmountCents: number;
  currency: string;
  productName: string;
}

export const PER_ACTION_PRICE: PerActionPrice = {
  priceId: "price_1TdsbDPlOPZU074wZgoNldCH", // €0.50/mo recurring (test mode); env STRIPE_PRICE_PER_ACTION overrides for live
  unitAmountCents: 50, // €0.50 / action / month — owner-set 2026-06-02
  currency: "eur",
  productName: "Aquino Compliance",
};

/** Resolve the active per-action price id, allowing an env override (live-key swap). */
export function resolvePerActionPriceId(env?: Record<string, string | undefined>): string {
  return env?.STRIPE_PRICE_PER_ACTION ?? PER_ACTION_PRICE.priceId;
}

const symbol = (currency: string) => (currency === "eur" ? "€" : currency === "usd" ? "$" : currency.toUpperCase() + " ");

/** "€2.00 / action / mo" */
export function formatPerActionUnit(p: PerActionPrice = PER_ACTION_PRICE): string {
  return `${symbol(p.currency)}${(p.unitAmountCents / 100).toFixed(2)} / action / mo`;
}

/** "€284.00 / mo" for a given active-action count. */
export function formatMonthlyEstimate(actionCount: number, p: PerActionPrice = PER_ACTION_PRICE): string {
  return `${symbol(p.currency)}${((actionCount * p.unitAmountCents) / 100).toFixed(2)} / mo`;
}
